import React from "react";
import ReactDOM from "react-dom";
import { Clock } from "lucide-react";

const IdleTimeoutModal = ({
  isVisible = false,
  onContinue = () => {},
  onRefresh = () => window.location.reload(),
}) => {
  const handleContinue = () => {
    onContinue();
  };

  const handleRefresh = () => {
    onRefresh();
    window.location.reload();
  };

  if (!isVisible) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4 animate-in fade-in duration-300">
      <div
        className="bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-300"
        style={{ width: "420px", maxWidth: "100%" }}
      >
        {/* Amber accent bar */}
        <div style={{ height: "5px", background: "#f59e0b" }} />

        <div className="p-6 flex flex-col gap-4">
          {/* Clock icon */}
          <div className="flex justify-center">
            <div
              className="flex items-center justify-center rounded-full"
              style={{ width: "64px", height: "64px", background: "#fffbeb" }}
            >
              <Clock size={32} color="#f59e0b" />
            </div>
          </div>

          {/* Title + Subtitle */}
          <div className="text-center">
            <h2 className="text-xl font-bold text-slate-800">Session Timeout</h2>
            <p className="text-sm text-slate-400 mt-1">
              You've been inactive for 15 minutes.
            </p>
          </div>

          {/* Divider */}
          <div className="border-t border-slate-100" />

          {/* Body */}
          <p className="text-sm text-slate-600 leading-relaxed text-center">
            Your session is about to expire. Choose{" "}
            <strong className="text-slate-800">Continue Session</strong> to stay
            logged in, or{" "}
            <strong className="text-slate-800">Refresh Page</strong> to reload
            the app.
          </p>

          {/* Divider */}
          <div className="border-t border-slate-100" />

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={handleRefresh}
              className="flex-1 border border-slate-200 text-slate-600 py-2.5 rounded-xl text-sm font-semibold hover:bg-slate-50 active:scale-95 transition-all"
            >
              Refresh Page
            </button>
            <button
              onClick={handleContinue}
              className="flex-1 py-2.5 rounded-xl text-sm font-bold text-white active:scale-95 transition-all"
              style={{ background: "#6366f1" }}
            >
              Continue Session
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default IdleTimeoutModal;
